import abl from '../abl';

const AuthAPI = abl.createClass({
	
	initialize: function(props) {
		this.requestor = props.requestor || {};
	},
	
	onAuthChange: function(callback) {
		return this.requestor.authenticate(callback);
	},

	signIn: function() {
		return this.requestor.signIn();
	}

});

export default AuthAPI;


/** WEBPACK FOOTER **
 ** ./src/js/clients/auth_api.js
 **/